

const Aqparameters = {
    settings() {
      return {
        H24Parameters: [
            {id: 8, name:'NO2', layername:'Last 24H NO2 mobile sensors', colorcodes: 'NO2Colors'}, 
            {id: 12, name: 'PM10.0', layername:'Last 24H PM10 mobile sensors', colorcodes: 'PM10Colors'}, 
            {id: 13, name: 'PM2.5', layername:'Last 24H PM2.5 mobile sensors', colorcodes: 'PM25Colors'}],
        LastHourParameters: [
            {id: 8, name:'NO2', layername:'Last available hour NO2 static sensors', colorcodes: 'NO2Colors'}, 
            {id: 12, name: 'PM10.0', layername:'Last available hour PM10 static sensors', colorcodes: 'PM10Colors'}, 
            {id: 13, name: 'PM2.5', layername:'Last available hour PM2.5 static sensors', colorcodes: 'PM25Colors'}],
      } 
    }   
  }
  
  export default Aqparameters;